module.exports = __webpack_public_path__ + "static/media/figma.45248535.png";